import type { IWebpageLinkResources } from "./WebpageLink.Resources";

export const WebpageLinkResourcesEn: IWebpageLinkResources = {
    text: "WWW page",
};
